import { render } from "./ShowEvent.vue?vue&type=template&id=503d4dc7"
import script from "./ShowEvent.vue?vue&type=script&lang=js"
export * from "./ShowEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__